module.exports = __webpack_public_path__ + "img/shield.cd3af20b.svg";